import { URLS } from "../../services/urls";


let ls = {}

ls.set = window.localStorage.setItem.bind(localStorage);
ls.get = window.localStorage.getItem.bind(localStorage);

const getUserDetails = () => JSON.parse( window.localStorage.getItem("user-details"));
const setUserDetails = (details) => window.localStorage.setItem("user-details", JSON.stringify(details));

const appScrollTo = (id) => {
    const element = document.getElementById(id);
    if (element) {
      // 👇 Will scroll smoothly to the top of the next section
      element.scrollIntoView({ behavior: 'smooth' });
    }
}

const formatLinkString = (link) => {
  if(link?.includes("https://")){
    return link;
  } else {
    return URLS.BASE_URL + link;
  }
}

const percentageFormater = (number)=>{
  const formater = new Intl.NumberFormat("EN",{
    style: 'percent',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  return number>1?formater.format(number/100):formater.format(number);
}
export {ls, setUserDetails, getUserDetails, appScrollTo, formatLinkString, percentageFormater}